<template>
  <svg width="24" height="24" viewBox="0 0 24 24"  xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.712 3C15.7472 3.01494 14.8034 3.28315 13.976 3.77753C13.1486 4.27192 12.4668 4.97497 11.9996 5.8157C11.5323 4.97497 10.8506 4.27192 10.0232 3.77753C9.19575 3.28315 8.25199 3.01494 7.2872 3C5.7492 3.06654 4.30015 3.73656 3.25664 4.86368C2.21312 5.99079 1.65997 7.48338 1.71802 9.01535C1.71802 12.895 5.81865 17.1322 9.25783 20.0051C10.0257 20.6477 10.9966 21 11.9996 21C13.0026 21 13.9735 20.6477 14.7413 20.0051C18.1805 17.1322 22.2811 12.895 22.2811 9.01535C22.3392 7.48338 21.786 5.99079 20.7425 4.86368C19.699 3.73656 18.25 3.06654 16.712 3Z"
      
    />
  </svg>
</template>
